module.exports = __webpack_public_path__ + "img/close-popup.fc1a618e.svg";